import React from "react";
import "./OrDivider.css";

export default class OrDivider extends React.Component {
  render() {
    return (
      <div style={{ width: "100%" }}>
        <h3 className="orDividerText">
          <span>{"   "}</span> OR <span>{"   "}</span>
        </h3>
      </div>
    );
  }
}
